import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '../contexts/AuthContext';
import api from '../lib/api';

const IDLE_MS = 30 * 60 * 1000;
const WARN_MS = IDLE_MS - 60 * 1000;
const REFRESH_EVERY_MS = 20 * 60 * 1000;

// Sesi habis setelah 30 menit tanpa aktivitas; aktivitas = permintaan apa pun ke
// server dari aplikasi (dicatat lewat interceptor di lib/api.js) atau interaksi mouse/keyboard.
export function useSessionTimeout() {
  const { user, logout, setUser } = useAuth();
  const navigate = useNavigate();
  const lastActivity = useRef(Date.now());
  const lastRefresh = useRef(Date.now());
  const [warning, setWarning] = useState(false);

  useEffect(() => {
    if (!user) return undefined;
    const mark = () => { lastActivity.current = Date.now(); };
    window.addEventListener('hisa-api-activity', mark);
    ['mousedown', 'keydown', 'touchstart'].forEach((e) => window.addEventListener(e, mark));

    const tick = setInterval(async () => {
      const idle = Date.now() - lastActivity.current;
      if (idle >= IDLE_MS) {
        logout();
        toast.warning('Sesi berakhir karena 30 menit tanpa aktivitas. Silakan login kembali.');
        navigate('/login');
        return;
      }
      setWarning(idle >= WARN_MS);
      if (idle < REFRESH_EVERY_MS && Date.now() - lastRefresh.current >= REFRESH_EVERY_MS) {
        lastRefresh.current = Date.now();
        try {
          const r = await api.post('/auth/refresh');
          localStorage.setItem('token', r.data.access_token);
          api.defaults.headers.common.Authorization = `Bearer ${r.data.access_token}`;
          if (r.data.user) setUser(r.data.user);
        } catch (e) { /* 401 ditangani interceptor */ }
      }
    }, 5000);

    return () => {
      clearInterval(tick);
      window.removeEventListener('hisa-api-activity', mark);
      ['mousedown', 'keydown', 'touchstart'].forEach((e) => window.removeEventListener(e, mark));
    };
  }, [user, logout, navigate, setUser]);

  const extend = () => { lastActivity.current = Date.now(); setWarning(false); };
  return { warning, extend };
}
